import { Table } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';

type CommonDataListProps<T> = {
  table: Table<T>;
  loading: boolean;
  error: Error | null;
  title?: string;
};

export const CommonDataList = <T,>({
  table,
  loading,
  error,
  title = 'データリスト',
}: CommonDataListProps<T>) => {
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div style={{ padding: '20px' }}>
      <h1>{title}</h1>
      <div style={{ margin: '5px' }}>
        <select
          className="border border-gray-400 rounded px-2 py-1 mr-2"
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              表示数 {pageSize}
            </option>
          ))}
        </select>
        <button className="inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          {'<'}
        </button>
        {table.getPageOptions().map((page) => {
          return (
            <button className="inline-flex items-center bg-gray-300 border border-gray-500 py-1 px-3 mx-1 rounded hover:bg-gray-400"
              key={page}
              onClick={() => table.setPageIndex(page)}
              disabled={table.getState().pagination.pageIndex === page}
            >
              {page + 1}
            </button>
          );
        })}
        <button className="inline-flex items-center bg-gray-300 border border-gray-500 py-1 px-3 mx-1 rounded hover:bg-gray-400"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          {'>'}
        </button>
      </div>
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          {/* ヘッダーグループを取得してループ */}
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {/* 各ヘッダーグループ内のヘッダーを取得してループ */}
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className="border px-4 py-2 text-left text-sm font-medium text-gray-700"
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        // ヘッダーの内容をレンダリング
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {/* 行モデルから行を取得してループ */}
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id} className="hover:bg-gray-50">
              {/* 各行の表示可能なセルを取得してループ */}
              {row.getVisibleCells().map((cell) => (
                <td
                  key={cell.id}
                  className="border px-4 py-2"
                >
                  {flexRender(
                    // セルの内容をレンダリング
                    cell.column.columnDef.cell,
                    cell.getContext()
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
